<template>
  <settings-card>
    <template v-slot:title>
      Quel niveau te correspond le plus ?
    </template>
    <!--
    <template v-slot:message v-if="messageDisplay">
      <div class="message">
        <div>
          <i class="fa-solid fa-lightbulb-exclamation-on"></i> Choisis le niveau qui te parait le plus adapté et nous selectionnerons le vocabulaire qui te correspond.
        </div>
        <div style="width: max-content" class="horizontalCenter">
          <standard-button @click="messageDisplay = false" :color-class="'olive'">Compris</standard-button>
        </div>
      </div>

    </template>
    -->
    <template v-slot:content>
      <div class="levelcontent centercenter">
        <div class="flexwrap centercenter">
          <div class="filterbuttonp clickable flexwrap centercenter"
               :style="{backgroundColor: levelBgColor(0), color: levelColor(0)}" @click="selectLevel(0)">
            A1
          </div>
          <div class="filterbuttonp clickable flexwrap centercenter"
               :style="{backgroundColor: levelBgColor(1), color: levelColor(1)}" @click="selectLevel(1)">
            A2
          </div>
          <div class="filterbuttonp clickable flexwrap centercenter"
               :style="{backgroundColor: levelBgColor(2), color: levelColor(2)}" @click="selectLevel(2)">
            B1
          </div>
          <div class="filterbuttonp clickable flexwrap centercenter"
               :style="{backgroundColor: levelBgColor(3), color: levelColor(3)}" @click="selectLevel(3)">
            B2
          </div>
          <div class="filterbuttonp clickable flexwrap centercenter"
               :style="{backgroundColor: levelBgColor(4), color: levelColor(4)}" @click="selectLevel(4)">
            C1
          </div>
        </div>

        <div class="clickable flexwrap centercenter paddingRound normalLink" style="position: absolute; top: 0; right: 0;">
          <a href="https://www.cambridgeenglish.org/fr/test-your-english/" title="Test ton niveau !" target="_blank"
             style="color: #162327"><i class="fas fa-question-circle"></i></a>
        </div>
        <transition name="slide-fade" mode="out-in">
          <span style="font-style: italic; text-align: center; font-size: 1.4em;" :key="tempProfile.estimated_level">{{levelSentence(tempProfile.estimated_level)}}</span>
        </transition>
        <standard-button id="saveProfileButton" @click="saveChanges" :inactive="saveInactive" :color-class="'olive'">Valider</standard-button>
      </div>

    </template>

  </settings-card>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {API_URL} from "@/App";
import axios from "axios";
import {manageUserDatas} from "@/mixins/manageUserDatas";
import SettingsCard from "@/components/settingsCard";

export default {
name: "my-level",

  mixins: [manageUserDatas],

  components: {
    SettingsCard,
    StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue'),
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },

  methods: {
    selectLevel: function (id) {
      this.saveInactive = false;
      this.tempProfile.estimated_level = id;
    },

    patchUserInfo() {
      let payload = {
        "estimated_level":this.tempProfile.estimated_level,
      }
      const url = `${API_URL}/api/auth0user/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.patch(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
              .then(response => {
                this.update_userDatas(response.data)
              })
        }
        else {
          console.log(error)
        }
      })
      // On actualise aussi les variables dans le store
      this.saveInactive = true

    },
    levelColor: function (difficulty) {
      if (difficulty === this.tempProfile.estimated_level) {
        return '#ece2cc'
      }
      else {
        return 'black';
      }
    },
    levelBgColor: function (difficulty) {
      if (difficulty === this.tempProfile.estimated_level) {
        return this.colorLevel[difficulty]
      } else {
        return 'rgba(76,76,76,0.27)';
      }
    },
    levelSentence: function(level){
      if(level==0){
        return '"Je débute et je souhaite apprendre le vocabulaire le plus basique !"'
      }
      if(level==1){
        return '"Je comprends les phrases et expressions sur des thèmes basiques (famille, travail, vie quotidienne)."'
      }
      if(level==2){
        return '"Je comprends les points essentiels d\'une discussion standard et clairement exprimée."'
      }
      if(level==3){
        return '"Je comprends le contenu essentiel de discussions sur des sujets assez complexes."'
      }
      if(level==4){
        return '"Je comprends les discussions longues et exigeantes et je saisis leurs significations implicites."'
      }
      return ""
    },
  },

  watch: {
    'tempProfile.estimated_level': function() {
      this.changedTempProfile(['estimated_level'])
    },
  },

  data() {
    return {
      saveInactive: false,
      //tempProfile: {},
      colorLevel: {
        0: "#56cdac",
        1: "#439f40",
        2: "#f49631",
        3: "#EB3B3B",
        4: "#40407F"
      },
      messageDisplay: true
    }
  }
}
</script>

<style scoped>

.levelcontent{
  display: grid;
  width: 50vw;
  max-width: 50vw;
  height: calc(100% - 2vw);
  max-height: calc(100% - 2vw);
  grid-template-rows: auto auto 1fr;
  position: relative;
  grid-gap: 1vw;
  padding: 1vw;
  /*border: 0.1vw var(--goalBackgroundColor) solid;
  border-radius: 1vw;*/
}


.filterbuttonp {
  margin: 1vw;
  height: 5vw;
  width: 5vw;
  border-radius: 4vw;
  font-size: 1.5em;
  font-weight: bold;
}

.understood {
  margin-left: auto;
  margin-right: auto;
}

.message {
  height: 100%;
  display: grid;
  grid-template-rows: 3fr 1fr;
}

@media screen and (max-device-width: 767px) {

  .levelcontent{
    width: calc(100% - 8vw);
    max-width: calc(100% - 8vw);
    height: 80%;
    max-height: 80%;
    padding: 4vw;
    grid-gap: 4vw;
    position: relative;
    justify-self: center;
  }

  .filterbuttonp {
    margin-right: 6vw;
    height: 15vw;
    width: 15vw;
    border-radius: 12vw;
    font-size: 1.2em;
    font-weight: bold;
  }
}
</style>